import React from 'react';
import { connect } from 'react-redux';
import { getAllOrders } from '../../../redux/actions/orders';
import ControlsComponent from '../../../components/OrderCard/Controls/Controls';

class Controls extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getVal() {
    const { orders, id } = this.props;
    let result = { prev: null, next: null },
      currentIndex;
    if (orders && orders.length > 1) {
      currentIndex = orders.findIndex(item => item.id === id);
      result.prev = currentIndex - 1 >= 0 ? orders[currentIndex - 1] : null;
      result.next =
        currentIndex + 1 <= orders.length ? orders[currentIndex + 1] : null;
    }
    return result;
  }

  componentDidMount() {
    const { orders } = this.props;
    if (!orders) {
      this.props.getAllOrders();
    }
  }

  render() {
    const val = this.getVal();
    return <ControlsComponent prev={val.prev} next={val.next} />;
  }
}

export default connect(
  state => ({
    orders: state.Executorship.Orders.orders.allOrders,
    isLoading: state.Executorship.Orders.orders.ordersLoading,
  }),
  {
    getAllOrders,
  }
)(Controls);
